import { normalizeImage } from '@/utils/image-resources'

export const RESOURCE_IMAGE_DRAG_TYPE = 'application/x-ironman-resource-image'
const dragging = new Map()

export function resourceImageComponent (baseList, resource) {
  const image = normalizeImage(resource)
  const base = baseList.flatMap(group => group.children).find(item => item.option.component.prop === 'img')
  if (!image || !image.available || !base) return null
  const option = JSON.parse(JSON.stringify(base.option))
  option.name = image.name
  option.title = image.name
  option.data = { value: image.url }
  // 保存具体版本及文件，渲染仍走已有 img 组件，不跟随资源库的 currentVersion。
  option.imageResource = { id: image.id, version: image.version, fileId: image.fileId }
  return option
}

export function beginImageDrag (resource) {
  endImageDrag()
  const image = normalizeImage(resource)
  if (!image || !image.available) return ''
  const key = Date.now().toString(36) + '-' + Math.random().toString(36).slice(2)
  dragging.set(key, image)
  return key
}

export function endImageDrag () { dragging.clear() }

export function resourceImageFromDrag (baseList, key) {
  // DataTransfer 仅接受本页刚刚登记的资源，不接受外部拖入的任意 URL 或 JSON。
  return resourceImageComponent(baseList, dragging.get(key))
}
